export default __webpack_public_path__ + "static/media/tbFormat2.ea0d161a.png";